import { propNameSelector } from '../utils';
import { handbookSelector, loadersSelector } from './root';

export const citiesListSelector = propNameSelector(handbookSelector, 'cities');
export const pointsListSelector = propNameSelector(handbookSelector, 'filials');
export const blockedPhonesListSelector = propNameSelector(handbookSelector, 'blockedPhones');
export const webhooksListSelector = propNameSelector(handbookSelector, 'webhooks');
export const loaderCitiesSelector = propNameSelector(loadersSelector, 'cities');
export const loaderPointsSelector = propNameSelector(loadersSelector, 'filials');
export const loaderBlockedPhonesSelector = propNameSelector(loadersSelector, 'blockedPhones');
export const loaderWebhooksSelector = propNameSelector(loadersSelector, 'webhooks');